import { useEffect, useState } from "react";
import { tourMembershipRepository } from "@/data/repositories/tourMembershipRepository";
import TourMembership from "@/models/TourMembership";

export function useTourMembership(tourId?: string, userId?: string) {
  const [membership, setMembership] = useState<TourMembership | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tourId || !userId) {
      setMembership(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    return tourMembershipRepository.subscribe(tourId, userId, nextMembership => {
      setMembership(nextMembership);
      setLoading(false);
    });
  }, [tourId, userId]);

  return { membership, loading };
}
